import React from "react";
import Flx from "../../../components/layout/Flx";
import PublicFormGrid from "../../../components/publicForm/PublicFormGrid";
import DisclosureBox from "../../../components/publicForm/DisclosureBox";
import PublicFormSection from "../../../components/publicForm/PublicFormSection";
import RffSignatureField from "../../../components/finalForm/inputs/RffSignatureField";
import { CREDIT_AUTH_PARAGRAPHS } from "../creditAuthShared";

/** Step 3 — the authorization agreement and signature. */
const StepCreditAuthSign = () => (
  <Flx column>
    <PublicFormSection title="Disclosure &amp; Signature">
      <Flx column gap={3}>
        <DisclosureBox
          title="Authorization Agreement."
          paragraphs={CREDIT_AUTH_PARAGRAPHS}
        />
        <PublicFormGrid>
          <RffSignatureField
            required
            name="signature"
            label="Signature"
            helperText="By signing, you authorize the credit and background checks described above."
          />
        </PublicFormGrid>
      </Flx>
    </PublicFormSection>
  </Flx>
);

export default StepCreditAuthSign;
